import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

const API_URL = `${process.env.REACT_APP_API_URL}/api/categorias`;

function AdminCategoria() {
  const [categorias, setCategorias] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [categoriaEditando, setCategoriaEditando] = useState(null);
  const [form, setForm] = useState({ nombre: "", descripcion: "" });

  const fetchCategorias = async () => {
    try {
      const res = await axios.get(`${API_URL}/all`);
      setCategorias(res.data);
    } catch {
      alert("Error al cargar categorías");
    }
  };

  useEffect(() => {
    fetchCategorias();
  }, []);

  const handleEditar = (cat) => {
    setCategoriaEditando(cat);
    setForm({ nombre: cat.nombre, descripcion: cat.descripcion || "" });
    setShowForm(true);
  };

  const handleNueva = () => {
    setCategoriaEditando(null);
    setForm({ nombre: "", descripcion: "" });
    setShowForm(true);
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta categoría?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/delete/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchCategorias();
    } catch {
      alert("Error al eliminar categoría");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

      if (categoriaEditando) {
        await axios.put(`${API_URL}/update/${categoriaEditando.id}`, form, { headers });
        alert("Categoría actualizada correctamente");
      } else {
        await axios.post(`${API_URL}/insert`, form, { headers });
        alert("Categoría agregada correctamente");
      }

      setShowForm(false);
      setCategoriaEditando(null);
      setForm({ nombre: "", descripcion: "" });
      fetchCategorias();
    } catch {
      alert("Error al guardar categoría");
    }
  };

  const categoriasFiltradas = categorias.filter((c) => {
    const texto = filterText.toLowerCase();
    return (
      c.nombre?.toLowerCase().includes(texto) ||
      c.descripcion?.toLowerCase().includes(texto)
    );
  });

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true, width: "70px" },
    { name: "Nombre", selector: (row) => row.nombre, sortable: true },
    { name: "Descripción", selector: (row) => row.descripcion || "—", wrap: true },
    {
      name: "Acciones",
      cell: (row) => (
        <div style={{ display: "flex", gap: "6px" }}>
          <button onClick={() => handleEditar(row)} style={{ padding: "3px 8px", cursor: "pointer" }}>
            ✏️ Editar
          </button>
          <button
            onClick={() => handleEliminar(row.id)}
            style={{ padding: "3px 8px", cursor: "pointer", color: "white", background: "#e53e3e", border: "none", borderRadius: "4px" }}
          >
            🗑️ Eliminar
          </button>
        </div>
      ),
      ignoreRowClick: true,
      width: "180px",
    },
  ];

  const subHeaderComponent = (
    <input
      type="text"
      placeholder="🔍 Buscar categoría..."
      value={filterText}
      onChange={(e) => setFilterText(e.target.value)}
      style={{ padding: "6px 10px", width: "250px", borderRadius: "4px", border: "1px solid #ccc" }}
    />
  );

  return (
    <div style={{ padding: "20px" }}>
      <h2>🗂️ Gestión de Categorías</h2>

      {!showForm && (
        <button onClick={handleNueva}>➕ Nueva Categoría</button>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "8px", maxWidth: "400px", marginBottom: "20px" }}>
          <h3>{categoriaEditando ? "✏️ Editar Categoría" : "➕ Nueva Categoría"}</h3>
          <label>Nombre</label>
          <input
            value={form.nombre}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
            required
          />
          <label>Descripción</label>
          <textarea
            value={form.descripcion}
            onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
            rows={3}
          />
          <div style={{ display: "flex", gap: "8px" }}>
            <button type="submit">{categoriaEditando ? "💾 Actualizar" : "💾 Guardar"}</button>
            <button type="button" onClick={() => { setShowForm(false); setCategoriaEditando(null); }}>
              Cancelar
            </button>
          </div>
        </form>
      )}

      <h3 style={{ marginTop: "20px" }}>📋 Listado de Categorías</h3>

      <DataTable
        columns={columns}
        data={categoriasFiltradas}
        pagination
        highlightOnHover
        striped
        responsive
        noDataComponent="No hay categorías disponibles"
        subHeader
        subHeaderComponent={subHeaderComponent}
      />
    </div>
  );
}

export default AdminCategoria;
